import { render, staticRenderFns } from "./menzhen-edit.vue?vue&type=template&id=094cc0c4&scoped=true&"
import script from "./menzhen-edit.vue?vue&type=script&lang=ts&"
export * from "./menzhen-edit.vue?vue&type=script&lang=ts&"
import style0 from "./menzhen-edit.vue?vue&type=style&index=0&id=094cc0c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094cc0c4",
  null
  
)

export default component.exports